import { MouseEvent, MouseEventHandler } from 'react';
import { GamePlayer, GamePlayerMark, PlayerO, PlayerX } from '../../utils';

import styles from './styles.module.css';

interface PlayerSwitchProps {
  selectedPlayer: GamePlayer;
  onPlayerSelected: (player: GamePlayer) => void;
}

const PlayerSwitch = (props: PlayerSwitchProps) => {
  const onClickHandler: MouseEventHandler = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    props.onPlayerSelected(event.currentTarget.getAttribute('data-player') as GamePlayer)
  }

  return (
    <div className={styles['player-mark-switch']}>
      <div
        className={`${styles['mark']} ${props.selectedPlayer === PlayerX && styles['selected']}`}
        data-player={PlayerX}
        onClick={onClickHandler}>
        {GamePlayerMark[PlayerX]}
      </div>
      <div
        className={`${styles['mark']} ${props.selectedPlayer === PlayerO && styles['selected']}`}
        data-player={PlayerO}
        onClick={onClickHandler} >
        {GamePlayerMark[PlayerO]}
      </div>
    </div>
  );
};

export default PlayerSwitch;
